import { render, staticRenderFns } from "./Parameter.vue?vue&type=template&id=1623b9cf"
import script from "./Parameter.vue?vue&type=script&lang=js"
export * from "./Parameter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports